import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { createSlice } from "@reduxjs/toolkit";

const getInitialState = () => ({
  isReply: false,
  replyMessage: null,
  editingMessage: null,
  isForward: false,
  forwardMessage: null,
  currentTyping: false,
});

const initialState = getInitialState();

const persistConfig = {
  key: "messageBox",
  storage,
  whitelist: [], // place to select which state you want to persist
};

const messageBoxConnectSlice = createSlice({
  name: "messageBoxConnect",
  initialState,
  reducers: {
    setIsReply: (state, action) => {
      state.isReply = action.payload;
    },
    setReplyMessage: (state, action) => {
      state.replyMessage = action.payload;
    },
    setEditingMessage: (state, action) => {
      state.editingMessage = action.payload;
    },
    setIsForward: (state, action) => {
      state.isForward = action.payload;
    },
    setForwardMessage: (state, action) => {
      state.forwardMessage = action.payload;
    },
    setCurrentTyping: (state, action) => {
      state.currentTyping = action.payload;
    },
    clearMessageBoxConnect: () => getInitialState(),
  },
});

export const {
  setIsReply,
  setReplyMessage,
  setEditingMessage,
  setIsForward,
  setForwardMessage,
  setCurrentTyping,
  clearMessageBoxConnect,
} = messageBoxConnectSlice.actions;

export default persistReducer(persistConfig, messageBoxConnectSlice.reducer);
